import { forwardRef, MouseEvent } from "react";
import { Filter24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Button, ButtonProps } from "@kaltura/ds-react-components";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * A button for opening the modal window with the filters.
 * The component doesn't contain the modal itself (see FilterBarButtonWithModal).
 */
export const FilterBarOpenButton = forwardRef<HTMLButtonElement, ButtonProps>(({ onClick, ...props }, ref) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleClick = (ev: MouseEvent<HTMLButtonElement>) => {
        sendButtonAnalytics("Open filters", ButtonClickAnalyticsType.TOGGLE);

        onClick?.(ev);
    };

    return (
        <Button
            ref={ref}
            startIcon={<Filter24Icon />}
            variant={"borderless"}
            color={"secondary"}
            aria-label={translate("open filters in a modal window")}
            onClick={handleClick}
            {...props}
        >
            {translate("Filters")}
        </Button>
    );
});
